import React from 'react'
import Topheader from '../../components/Topheader'
import style from './styles.module.css'
export default function Rewardpoints() {
    return (
        <div>
            <Topheader colorbox="newfaq_header_color" title="Reward Points" />
            <div className="main-container mb-5 px-3">
                <div className={style.sub_text2_q}>
                    Q.  What are Reward Points?
                </div>
                <div className={style.sub_text3}>
                    Reward Points are the in-game currency you earn by playing, winning tournaments, and ranking on leaderboards. You can redeem them in the Baazi Store for exclusive offers and gift cards.
                </div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>
                    Q.    What can I buy using Reward Points?
                </div>
                <div className={style.sub_text3}>
                    Reward Points can be redeemed at the Baazi Store to claim cool rewards available at the time. New rewards are added regularly, keep checking back.
                </div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>Q.  Do I need to spend money to earn Reward Points? </div>
                <div className={style.sub_text3}>No. Just use your Free Chips smartly. Play, compete, and earn points. No payment needed. </div>
                <div className={style.brd}></div>


                <div className={style.sub_text2_q}>Q.  Do Reward Points expire? </div>
                <div className={style.sub_text3}>Not immediately, but unused points may reset during season refresh cycles. Stay active to keep climbing and redeeming.  </div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>Q.  Is there a monthly limit on redemptions? </div>
                <div className={style.sub_text3}>Yes, you can make a maximum of 30 redemptions per month using your Reward Points.  </div>
                <div className={style.brd}></div>


                <div className={style.sub_text2_q}>Q.  Can Reward Points be converted to cash?  </div>
                <div className={style.sub_text3}>No. Reward Points can only be used to redeem for rewards at the Baazi Store.   </div>
                <div className={style.brd}></div>



                <div className={style.sub_text2_q}>Q.  My Reward Points didn’t get added. What should I do?  </div>
                <div className={style.sub_text3}>Refresh the app or log out and back in. If the issue persists, reach out to us at <a href='mailto:playerrelations@pokerbaazi.net'>playerrelations@pokerbaazi.net</a> with your username and gameplay details.    </div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>Q.  I redeemed my Reward Points but didn’t receive the item.  </div>
                <div className={style.sub_text3}>Please allow up to 48 hours for processing. If not received, contact us at <a href='mailto:playerrelations@pokerbaazi.net'>playerrelations@pokerbaazi.net</a> with your shortlisted reward name and redemption date for assistance.
                </div>
                <div className={style.brd}></div>




                <div className={style.sub_text3}> For more detailed FAQs, visit the Reward Points section inside the app.</div>

            </div>
        </div>
    )
}

